import { api } from "constants/RotasAPI";
import usePut from "hooks/usePut";
import { AssinanteDocumentoDTO } from "types/dto/groupsign/AssinanteDocumentoDTO";

export const usePutAtualizarAssinanteDocumento = () => {
  return usePut<AssinanteDocumentoDTO>({
    url: `${api.groupsign.assinanteDocumento}`,
  });
};
